import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase, CustomerInfo, CustomerType, User, SettingsService } from 't4core';
import { VerifyAccountComponent } from '../../../MyPage/Components/verify-account/verify-account.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AppSettingsService } from 't4-app-integration';
import { PinCodeDialog } from '../../Dialogs/pin-code-dialog/pin-code-dialog';
import { UntypedFormControl } from '@angular/forms';
import { NavigationService } from 'app-components';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: false
})
export class SettingsComponent extends PageBase implements OnInit {
  public customerType = CustomerType;
  public settingsChanged: boolean = true;
  public languages: string[][] = [["sv", "Svenska"], ["da", "Dansk"], ["de", "Deutsch"], ["en", "English"], ["no", "Norsk"], ["it", "Italiano"], ["fr", "Français"], ["fi", "Suomi"]];
  public language: string = "en";
  public user: User;
  public customer: CustomerInfo;
  public validCustomer = false;

  public Email: string;
  public MobilePhone: string;

  public outline: string = "outline";

  public isCustomerChanged: boolean;

  public openDialogCounter: number = 0;
  public demoSettings: boolean = false;
  public atLocation: boolean = false;
  public demoPhotos: boolean = false;
  public bypassLock: boolean = false;
  public unlockAnyLock: boolean = false;
  public unshackle: boolean = false;
  public enableOffersChanged: boolean = false;


  public userLoggedIn: boolean = false;

  public isLoading: boolean = false;

  constructor(
    el: ElementRef,
    public appSettings: AppSettingsService,
    private navigationService: NavigationService,
    private settings: SettingsService
  ) {
    super(el);
  }

  async ngOnInit() {

    this.isLoading = true;

    //Uncomment once arabic has been properly implemented.
    /*
    if (this.settings.Environment != 0) {
      this.languages.push(["ar", "Arabic"]);
    }
    */

    this.userLoggedIn = this.appSettings.userLoggedIn;

    if (this.userLoggedIn) {
      await this.getSettings();
      await this.getCustomerInfo();
    }

    this.language = this.getLanguage();

    this.updateDemoSettings();
    this.isLoading = false;
  }

  public async toggleDemoSettings(event: MatSlideToggleChange) {
    console.log(event);

    var passedVerification = true;

    if (event.checked) {
      passedVerification = await this.verifyDemoSettingsUnlock();
      this.demoSettings = passedVerification;
    }
    else {
      this.demoSettings = false;
    }

    if (event.checked && passedVerification) {
      localStorage.setItem('demoSettings', 'true');
      localStorage.setItem('atLocation', 'false');
      localStorage.setItem('takePhoto', 'false');
      localStorage.setItem('bypassLock', 'false');
      localStorage.setItem('unlockAnyLock', 'false');
    }
    else {
      localStorage.removeItem('demoSettings');
      localStorage.removeItem('atLocation');
      localStorage.removeItem('takePhoto');
      localStorage.removeItem('bypassLock');
      localStorage.removeItem('unlockAnyLock');
    }

    this.updateDemoSettings();

    event.source.checked = passedVerification;

  }

  public updateDemoSettings() {
    if (localStorage.getItem('demoSettings')) {
      this.demoSettings = localStorage.getItem('demoSettings') ? true : false;
    }
    else {
      this.demoSettings = false;
    }

    if (localStorage.getItem('atLocation')) {
      this.atLocation = localStorage.getItem('atLocation') == "true" ? true : false;
    }
    else {
      this.atLocation = false;
    }

    if (localStorage.getItem('takePhoto')) {
      this.demoPhotos = localStorage.getItem('takePhoto') == "demo" ? true : false;
    }
    else {
      this.demoPhotos = false;
    }

    if (localStorage.getItem('bypassLock')) {
      this.bypassLock = localStorage.getItem('bypassLock') == "true" ? true : false;
    }
    else {
      this.bypassLock = false;
    }

    if (localStorage.getItem('unlockAnyLock')) {
      this.unlockAnyLock = localStorage.getItem('unlockAnyLock') == "true" ? true : false;
    }
    else {
      this.unlockAnyLock = false;
    }

    if (localStorage.getItem('unshackle')) {
      this.unshackle = localStorage.getItem('unshackle') == "true" ? true : false;
    }
    else {
      this.unshackle = false;
    }
  }

  public async toggleAdvertisements(event: MatSlideToggleChange) {
    this.customer.ReceivingAdvertising = event.checked;
    this.enableOffersChanged = true;
  }


  public async changeBookingType(event: MatSlideToggleChange) {
    this.atLocation = event.checked;

    if (event.checked) localStorage.setItem('atLocation', 'true');
    else localStorage.setItem('atLocation', 'false');
  }

  public async changeLockBypass(event: MatSlideToggleChange) {
    this.bypassLock = event.checked;

    if (event.checked) localStorage.setItem('bypassLock', 'true');
    else localStorage.setItem('bypassLock', 'false');
  }

  public async changePhotoType(event: MatSlideToggleChange) {
    this.demoPhotos = event.checked;

    if (event.checked) localStorage.setItem('takePhoto', 'demo');
    else localStorage.setItem('takePhoto', 'false');
  }

  public async toggleAdminUnlockAccess(event: MatSlideToggleChange) {
    this.unlockAnyLock = event.checked;

    if (event.checked) localStorage.setItem('unlockAnyLock', 'true');
    else localStorage.setItem('unlockAnyLock', 'false');
  }

  public async toggleUnshackleAccess(event: MatSlideToggleChange) {
    this.unshackle = event.checked;

    if (event.checked) localStorage.setItem('unshackle', 'true');
    else localStorage.setItem('unshackle', 'false');
  }

  public async getSettings() {
    this.user = this.Settings.getUser();
    let userDetails = await this.Api.get<any>("Settings/getUserDetails");
    this.Email = userDetails.Email;
    this.MobilePhone = userDetails.MobilePhone;
  }

  private getLanguage(): string {
    return this.appSettings.getLanguage();
  }

  private async getCustomerInfo(): Promise<void> {
    this.customer = await this.Api.get<CustomerInfo>("Rental/FindCustomerByUser", { userID: this.Settings.getUser().Username });
    this.validCustomer = (this.customer != null);
  }

  public phoneChange(control: UntypedFormControl) {
    this.MobilePhone = control.value || this.MobilePhone;
  }

  public async openDialog(newPhone: string = null): Promise<any> {
    const dialogRef = this.Dialog.open(VerifyAccountComponent, {
      width: '350px',
      position: { top: '50px' },
      data: { verified: false, isBooking: true, MobilePhone: this.MobilePhone, Email: this.Email, newPhone: newPhone }
    });
    var result = await dialogRef.afterClosed().toPromise();
    return result;
  }

  public async saveChanges() {
    if (this.validCustomer) {
      var token = this.UI.beginLoading("Intellitrailer.MyPage.Settings.msgLoadingOptions", "Saving settings", null);
      await this.Api.post<boolean>("Account/EditUserInfo", null,
        { username: this.user.Username, email: this.customer.Email, language: this.language });
      await this.saveCustomer();
      this.UI.loaderCompleted(token);
    }
    await this.saveLanguage();
    this.setAsChanged(false);
    if (this.enableOffersChanged) {
      this.Insights.trackTrace("The customer " + this.customer.Email + "(" + this.customer.Id + ") changed the enable offers to " + this.customer.ReceivingAdvertising); 
      this.enableOffersChanged = false;
    }
  }

  public setAsChanged(value: boolean) {
    this.settingsChanged = value;
  }



  public async deleteAccount() {
    if (await this.UI.confirm("Intellitrailer.Menu.headConfirmDeleteUser2", "Confirm deletion", "Intellitrailer.Menu.msgConfirmDeleteUser2", "Do you want do delete your account? If you have any active bookings those will be automaitcally canceled.")) {

      var respons = await this.Api.post<any>("Customer/DeleteCustomerDataIfEligible", this.customer);
      if (respons == 0 || respons == 6 || respons == 7) { //OK, DeletedFromT4_NoPaymentFound, Already Processed.
        if (await this.navigationService.isAuthenticationRequired("Start") && !this.appSettings.userId) {
          this.navigationService.navigateToView("MyPage.SignIn");
        } else {
          this.navigationService.navigateToView("Start");
        }
        this.appSettings.setUser(null);

        await this.UI.alert(
          "Intellitrailer.Menu.headAccountDeleted",
          "Your account has been removed!",
          "Intellitrailer.Menu.msgAccountDeleted",
          "Please note that your account will be recreated if you try to sign in again.");


      }
      else if (respons == 3) {
        await this.UI.alert(
          "Intellitrailer.Menu.headAccountDeletedPendingBooking",
          "Unable to delete your account",
          "Intellitrailer.Menu.msgAccountDeletedPendingBooking",
          "Unable to delete your account, you have an active or pending booking.");
      }
      else if (respons == 4) {
        await this.UI.alert(
          "Intellitrailer.Menu.headAccountDeletedRecentBooking",
          "Unable to delete your account",
          "Intellitrailer.Menu.msgAccountDeletedRecentBooking",
          "Unable to delete your account, you have had an active booking in last 30 days.");
      }
      else
        await this.UI.alert(
          "Intellitrailer.Menu.headAccountDeleteUnknownError",
          "Unable to delete your account",
          "Intellitrailer.Menu.msgAccountDeletedUnknownError",
          "Unable to delete your account, something went wrong.");
    }

  }



  private async saveCustomer(): Promise<boolean> {
    if (!this.customer || !this.validCustomer) {
      this.UI.alert(
        "Intellitrailer.MyPage.Settings.headInvalidCustomerInformation",
        "The customer could not be saved",
        "Intellitrailer.MyPage.Settings.msgInvalidCustomerInformation",
        "The customer is missing or contains invalid information.");
      return false;
    }
    var savedCustomer = await this.Api.post<CustomerInfo>("Rental/SaveCustomer", this.customer, { isOneWay: this.Settings.clientSettings.IsOneWay });
    this.customer = savedCustomer;
    this.appSettings.customer = savedCustomer;
    this.appSettings.getUser();
  }

  public async verifyDemoSettingsUnlock(): Promise<boolean> {
    const dialogRef = this.Dialog.open(PinCodeDialog, {
      position: { top: '50px' },
      disableClose: true,
      data: { verified: false, isBooking: false, contextChange: true }
    });
    var result = await dialogRef.afterClosed().toPromise();
    return result == '9600';
  }

  private async saveLanguage() {
    const currentLang = this.appSettings.getLanguage();
    this.appSettings.setLanguage(this.language);

    if (this.language !== currentLang) {
      window.location.reload();
    }
  }

  public openTestVersion() {
    let testUri = `https://t4-booking-test.azurewebsites.net/?externalId=${this.appSettings.contextId}&privateKey=${this.appSettings.privateKey}&scheme=${this.appSettings.appScheme}&appVersion=${this.appSettings.appVersion}&appType=${this.appSettings.appType}`;
    window.location.href = testUri;
  }

  public openNewAppService() {
    let newUri = `https://t4-booking-prod-test.azurewebsites.net/?externalId=${this.appSettings.contextId}&privateKey=${this.appSettings.privateKey}&scheme=${this.appSettings.appScheme}&appVersion=${this.appSettings.appVersion}&appType=${this.appSettings.appType}`;
    window.location.href = newUri;
  }

  public async navigate(command: string) {
    if (await this.navigationService.isAuthenticationRequired(command) && !this.appSettings.userId) {
      this.navigationService.navigateToView("MyPage.SignIn");
    } else {
      this.navigationService.navigateToView(command);
    }
  }
  

}
